module.exports = __webpack_public_path__ + "static/media/user10.f092d93f.gif";